module.exports = __webpack_public_path__ + "static/media/loading1.3f259006.gif";